import {store} from '@/redux-store/store';

export const getDirectChatRoomId = (userId: string): string | null => {
  const directMap: Record<string, string[]> =
    store.getState().matrixRooms.directChatData;
  if (directMap[userId] && directMap[userId].length > 0) {
    return directMap[userId][0];
  }
  return null;
};
